import { render, staticRenderFns } from "./argueCategory.vue?vue&type=template&id=1f750209&scoped=true"
import script from "./argueCategory.vue?vue&type=script&lang=js"
export * from "./argueCategory.vue?vue&type=script&lang=js"
import style0 from "./argueCategory.vue?vue&type=style&index=0&id=1f750209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f750209",
  null
  
)

export default component.exports